import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class Label extends Component {
  static propTypes = {
    name: PropTypes.string,
    removable: PropTypes.bool,
    color: PropTypes.string,
    onRemove: PropTypes.func
  };
  static defaultProps = {
    name: "",
    removable: false,
    color: "orange"
  };

  render() {
    const { removable, name } = this.props;
    return (
      <Wrapper {...this.props}>
        <Name removable={removable}>{name.toUpperCase()}</Name>
        {removable && (
          <Icon name="x-button" width={8} height={8} onClick={this.onRemove} />
        )}
      </Wrapper>
    );
  }


  onRemove = () => {
    const { name, onRemove } = this.props;
    if (onRemove) onRemove(name);
  };
}

const Wrapper = styled.div`
  display: inline-flex;
  vertical-align: top;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 6px;
  border-radius: 3px;
  margin-right: 2px;
  height: auto;
  background-color: ${props => props.color};
  max-width: ${props => (props.removable ? "auto" : "50px")};
  cursor: default;
  user-select: none;
  margin-bottom: 2px;
`;
const Name = styled.span`
  font-size: 0.6rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: white;
  margin-right: ${props => (props.removable ? "6px" : "none")};
`;



// WEBPACK FOOTER //
// ./src/module-common/label-list/Label.js